export const TS = {
  TXT_ARE_YOU_SURE: 'txt_are_you_sure',
  TXT_BACK: 'txt_back',
  TXT_CANCEL: 'txt_cancel',
  TXT_YES: 'txt_yes',
  LABEL_WARNING: 'label_warning',
  CARDS_LABEL_USED: 'cards_label_used',
  LABEL_CONTINUE: 'label_continue',
  SETTINGS_DELETE_ACC: 'settings_delete_acc',
  LABEL_ARE_YOU_SURE: 'label_are_you_sure',
  NOTIFICATIONS_CHANGE_SERVICE: 'notifications_change_service',
  NEW_ORDER_MIN_VAL: 'new_order_min_val',
  NEW_ORDER_SAVING: 'new_order_saving',
  NEW_ORDER_AUTO_SAVE: 'new_order_auto_save',
  NEW_ORDER_CALENDAR_INVALID: 'new_order_calendar_invalid',
  NEW_ORDER_CALENDAR_INVALID_DATE: 'new_order_calendar_invalid_date',
  NEW_ORDER_CALENDAR_DURATION: 'new_order_calendar_duration',
  NEW_ORDER_CALENDAR_START_DATE: 'new_order_calendar_start_date',
  NEW_ORDER_CALENDAR_END_DATE: 'new_order_calendar_end_date',
  NEW_ORDER_CALENDAR_START_TIME: 'new_order_calendar_start_time',
  NEW_ORDER_CALENDAR_END_TIME: 'new_order_calendar_end_time',
  NEW_ORDER_CALENDAR_EQUAL: 'new_order_calendar_equal',
  NEW_ORDER_TIME_CHOOSE_OPTION: 'new_order_time_choose_option',
  NEW_ORDER_TIME_EXACT_DATE: 'new_order_time_exact_date',
  NEW_ORDER_TIME_ENTER_SCHEDULE: 'new_order_time_enter_schedule',
  APPLICANT_AGE_RANGE: 'applicant_age_range',
  PRODUCT_WORKER_TYPE: 'product_worker_type',
  NEW_ORDER_FORM_PAYMENT_NO_PAYMENT_SETUP:
    'new_order_form_payment_no_payment_setup',
  REQUIRED_LABEL: 'required_label',
  DIFFERENT_TIMEZONE_ERROR: 'different_timezone_error',
  CREATE_ORDER_TASK_PRICE_FIXED: 'create_order_task_price_fixed',
  CREATE_ORDER_TASK_PRICE_HOUR: 'create_order_task_price_hour',
  CREATE_ORDER_TASK_PRICE_DAY: 'create_order_task_price_day',
  CREATE_ORDER_TASK_PRICE_MONTH: 'create_order_task_price_month',
  CREATE_ORDER_TASK_PRICE_UNIT: 'create_order_task_price_unit',
  ERROR_NOT_APPROVED_WORKER: 'error_not_approved_worker',
  ERROR_NOT_APPROVED_ORDERER: 'error_not_approved_orderer',
  ADD_HOURS: 'add_hours',
  ADD_DAYS: 'add_days',
  ADD_MONTHS: 'add_months',
  ADD_UNITS: 'add_units',
  ADD_PRICE: 'add_price',
  PAYMENT_AND_REPORTS: 'payment_and_reports',
  LABEL_HOURS: 'label_hours',
  LABEL_DAYS: 'label_days',
  LABEL_MONTHS: 'label_months',
  LABEL_UNITS: 'label_units',
  LABEL_PRICE: 'label_price',
  ORDER_DETAILS_DURATION_INFO: 'order_details_duration_info',
  ORDER_DETAILS_DURATION_LABEL: 'order_details_duration_label',
  ORDER_DETAILS_DURATION_EXP: 'order_details_duration_exp',
  ORDER_DETAILS_DURATION_WARNING_INFO: 'order_details_duration_warning_info',
  ORDER_DETAILS_DURATION_WARNING_REASON:
    'order_details_duration_warning_reason',
  ORDER_DETAILS_DURATION_WARNING_CURRENT:
    'order_details_duration_warning_current',
  ORDER_DETAILS_DURATION_WARNING_ORIGINAL:
    'order_details_duration_warning_original',
  ORDER_DETAILS_DURATION_WARNING_LABEL: 'order_details_duration_warning_label',
  ORDER_DETAILS_MINUTES: 'order_details_minutes',
  ORDER_DETAILS_DURATION_CANT_MODIFY: 'order_details_duration_cant_modify',
  ORDER_DETAILS_DURATION_ORDERER_APPR: 'order_details_duration_orderer_appr',
  ORDER_DETAILS_DURATION_WORKER: 'order_details_duration_worker',
  ORDER_DETAILS_DURATION_ORIGINAL_PRICE:
    'order_details_duration_original_price',
  ORDER_DETAILS_DURATION_CURRENT_PRICE: 'order_details_duration_current_price',
  ORDER_DETAILS_DURATION_ORIGINAL_AMOUNT:
    'order_details_duration_original_amount',
  ORDER_DETAILS_DURATION_UPDATED_AMOUNT:
    'order_details_duration_updated_amount',
  ORDER_DETAILS_DURATION_ORDERER_NOT_APPR:
    'order_details_duration_orderer_not_appr',
  REGISTER_CHANGE_TO_PRIVATE: 'register_change_to_private',
  REGISTER_CHANGE_TO_PUBLIC: 'register_change_to_public',
  ORDER_DETAILS_DURATION_EDIT: 'order_details_duration_edit',
  ORDER_DETAILS_DURATION_EDIT_INFORMATION:
    'order_details_duration_edit_information',
  HOME_SWITCH_MERCHANT_MESSAGE: 'home_switch_merchant_message',
  INPUT_FIELD_MAX_CHAR_ERROR: 'input_field_max_char_error',
  PROFILE_FEEDBACKS: 'profile_feedbacks',
  ORDER_ADD_COMPLETION_DATE: 'order_add_completion_date',
  ORDER_CHANGE_DURATION_IF_NEEDED: 'order_change_duration_if_needed',
  ORDER_CHANGE_DURATION: 'order_change_duration',
  PILOT_POINTS_ASK_FOR_BILLING: 'pilot_points_ask_for_billing',
  PILOT_POINTS_EMAIL_FOR_BILLING: 'pilot_points_email_for_billing',
  PILOT_POINTS_BUSINESS_ID: 'pilot_points_business_id',
  PILOT_POINTS_E_INVOICE_ADDRESS: 'pilot_points_e_invoice_address',
  PILOT_POINTS_E_INVOICE_OPERATOR: 'pilot_points_e_invoice_operator',
  PILOT_POINTS_INVOICE_REFERENCE: 'pilot_points_invoice_reference',
  PILOT_POINTS_UI_EXPLANATION: 'pilot_points_ui_explanation',
  PILOT_POINTS_SUCCESS_MESSAGE: 'pilot_points_success_message',
  PILOT_POINTS_DIALOG_AMOUNT_SUPPLEMENT:
    'pilot_points_dialog_amount_supplement',
  PILOT_POINTS_DIALOG_AMOUNT: 'pilot_points_dialog_amount',
  PILOT_POINTS_BASIC_INFORMATION: 'pilot_points_basic_information',
  PILOT_POINTS_INVOICE_INFORMATION: 'pilot_points_invoice_information',
  PILOT_POINTS_ENTER_EMAIL: 'pilot_points_enter_email',
  PILOT_POINTS_BY_BILLING_REQUEST: 'pilot_points_by_billing_request',
  LABEL_OVER_18: 'label_over_18',
  ERROR_ORDER_AMOUNT_SMALLER_THAN_THE_MINIMUM: 'error_order_amount_smaller_than_the_minimum',
  ORDER_STATUS_WORKER_SELECTED: 'order_status_worker_selected',
  ORDER_STATUS_RECEIVED_TASK: 'order_status_received_task',
  ORDER_STATUS_APPLIED: 'order_status_applied',
  CALENDAR_DAYS: 'calendar_days',

  PILOT_POINTS_BUY_BUY_AMOUNT_LABEL: 'pilot_points_buy_buy_amount_label',
  PILOT_POINTS_CATEGORY_AND_UNITS: 'pilot_points_category_and_units',
  PILOT_POINTS_ANY_AMOUNT: 'pilot_points_any_amount',
  PILOT_POINTS_CHOOSE_CATEGORY: 'pilot_points_choose_category',
  PILOT_POINTS_UNITS: 'pilot_points_units',

  TABLE_HEADER_PAYMENT_FAILED: 'table_header_payment_failed',
  SETTINGS_PAYMENT_INFO: 'settings_payment_info',
  SETTINGS_PW_CHANGE_ERROR: 'settings_pw_change_error',
  PW_IS_TOO_LONG: 'is_too_long',
  PW_IS_TOO_SHORT: 'pw_is_too_short',
  IS_TOO_SHORT: 'is_too_short',
  NOT_THE_SAME_AS_PASSWORD: 'not_the_same_as_password',

  TABLE_FILTERS_FILTER: 'table_filters_filter',
  TABLE_FILTERS_CLEAR: 'table_filters_clear',
  TABLE_FILTERS_START: 'table_filters_start',
  TABLE_FILTERS_INIT_ORDER: 'table_filters_init_order',
  TABLE_FILTERS_ORDERBY: 'table_filters_orderby',
  TABLE_FILTERS_INIT_DATE: 'table_filters_init_date',
  TABLE_FILTERS_WORKER: 'table_filters_worker',
  TABLE_FILTERS_SORTING: 'table_filters_sorting',
  TABLE_FILTERS_DESCENDING: 'table_filters_descending',
  TABLE_FILTERS_ASCENDING: 'table_filters_ascending',
  TABLE_FILTERS_PRODUCT: 'table_filters_product',
  TABLE_FILTERS_TEAM: 'table_filters_team',
  TABLE_FILTERS_CITY: 'table_filters_city',
  TABLE_HIDE_CANCELLED_LABEL: 'table_hide_cancelled_label',

  SETTINGS_LANG_AA: 'settings_lang_aa',
  SETTINGS_LANG_AB: 'settings_lang_ab',
  SETTINGS_LANG_AF: 'settings_lang_af',
  SETTINGS_LANG_AK: 'settings_lang_ak',
  SETTINGS_LANG_AM: 'settings_lang_am',
  SETTINGS_LANG_AR: 'settings_lang_ar',
  SETTINGS_LANG_AN: 'settings_lang_an',
  SETTINGS_LANG_AS: 'settings_lang_as',
  SETTINGS_LANG_AV: 'settings_lang_av',
  SETTINGS_LANG_AE: 'settings_lang_ae',
  SETTINGS_LANG_AY: 'settings_lang_ay',
  SETTINGS_LANG_AZ: 'settings_lang_az',
  SETTINGS_LANG_BA: 'settings_lang_ba',
  SETTINGS_LANG_BM: 'settings_lang_bm',
  SETTINGS_LANG_BE: 'settings_lang_be',
  SETTINGS_LANG_BN: 'settings_lang_bn',
  SETTINGS_LANG_BI: 'settings_lang_bi',
  SETTINGS_LANG_BO: 'settings_lang_bo',
  SETTINGS_LANG_BS: 'settings_lang_bs',
  SETTINGS_LANG_BR: 'settings_lang_br',
  SETTINGS_LANG_BG: 'settings_lang_bg',
  SETTINGS_LANG_CA: 'settings_lang_ca',
  SETTINGS_LANG_CS: 'settings_lang_cs',
  SETTINGS_LANG_CH: 'settings_lang_ch',
  SETTINGS_LANG_CE: 'settings_lang_ce',
  SETTINGS_LANG_CU: 'settings_lang_cu',
  SETTINGS_LANG_CV: 'settings_lang_cv',
  SETTINGS_LANG_KW: 'settings_lang_kw',
  SETTINGS_LANG_CO: 'settings_lang_co',
  SETTINGS_LANG_CR: 'settings_lang_cr',
  SETTINGS_LANG_CY: 'settings_lang_cy',
  SETTINGS_LANG_DA: 'settings_lang_da',
  SETTINGS_LANG_DE: 'settings_lang_de',
  SETTINGS_LANG_DV: 'settings_lang_dv',
  SETTINGS_LANG_DZ: 'settings_lang_dz',
  SETTINGS_LANG_EL: 'settings_lang_el',
  SETTINGS_LANG_EN: 'settings_lang_en',
  SETTINGS_LANG_EO: 'settings_lang_eo',
  SETTINGS_LANG_ET: 'settings_lang_et',
  SETTINGS_LANG_EU: 'settings_lang_eu',
  SETTINGS_LANG_EE: 'settings_lang_ee',
  SETTINGS_LANG_FO: 'settings_lang_fo',
  SETTINGS_LANG_FA: 'settings_lang_fa',
  SETTINGS_LANG_FJ: 'settings_lang_fj',
  SETTINGS_LANG_FI: 'settings_lang_fi',
  SETTINGS_LANG_FR: 'settings_lang_fr',
  SETTINGS_LANG_FY: 'settings_lang_fy',
  SETTINGS_LANG_FF: 'settings_lang_ff',
  SETTINGS_LANG_GD: 'settings_lang_gd',
  SETTINGS_LANG_GA: 'settings_lang_ga',
  SETTINGS_LANG_GL: 'settings_lang_gl',
  SETTINGS_LANG_GV: 'settings_lang_gv',
  SETTINGS_LANG_GN: 'settings_lang_gn',
  SETTINGS_LANG_GU: 'settings_lang_gu',
  SETTINGS_LANG_HT: 'settings_lang_ht',
  SETTINGS_LANG_HA: 'settings_lang_ha',
  SETTINGS_LANG_SH: 'settings_lang_sh',
  SETTINGS_LANG_HE: 'settings_lang_he',
  SETTINGS_LANG_HZ: 'settings_lang_hz',
  SETTINGS_LANG_HI: 'settings_lang_hi',
  SETTINGS_LANG_HO: 'settings_lang_ho',
  SETTINGS_LANG_HR: 'settings_lang_hr',
  SETTINGS_LANG_HU: 'settings_lang_hu',
  SETTINGS_LANG_HY: 'settings_lang_hy',
  SETTINGS_LANG_IG: 'settings_lang_ig',
  SETTINGS_LANG_IO: 'settings_lang_io',
  SETTINGS_LANG_II: 'settings_lang_ii',
  SETTINGS_LANG_IU: 'settings_lang_iu',
  SETTINGS_LANG_IE: 'settings_lang_ie',
  SETTINGS_LANG_IA: 'settings_lang_ia',
  SETTINGS_LANG_ID: 'settings_lang_id',
  SETTINGS_LANG_IK: 'settings_lang_ik',
  SETTINGS_LANG_IS: 'settings_lang_is',
  SETTINGS_LANG_IT: 'settings_lang_it',
  SETTINGS_LANG_JV: 'settings_lang_jv',
  SETTINGS_LANG_JA: 'settings_lang_ja',
  SETTINGS_LANG_KL: 'settings_lang_kl',
  SETTINGS_LANG_KN: 'settings_lang_kn',
  SETTINGS_LANG_KS: 'settings_lang_ks',
  SETTINGS_LANG_KA: 'settings_lang_ka',
  SETTINGS_LANG_KR: 'settings_lang_kr',
  SETTINGS_LANG_KK: 'settings_lang_kk',
  SETTINGS_LANG_KM: 'settings_lang_km',
  SETTINGS_LANG_KI: 'settings_lang_ki',
  SETTINGS_LANG_RW: 'settings_lang_rw',
  SETTINGS_LANG_KY: 'settings_lang_ky',
  SETTINGS_LANG_KV: 'settings_lang_kv',
  SETTINGS_LANG_KG: 'settings_lang_kg',
  SETTINGS_LANG_KO: 'settings_lang_ko',
  SETTINGS_LANG_KJ: 'settings_lang_kj',
  SETTINGS_LANG_KU: 'settings_lang_ku',
  SETTINGS_LANG_LO: 'settings_lang_lo',
  SETTINGS_LANG_LA: 'settings_lang_la',
  SETTINGS_LANG_LV: 'settings_lang_lv',
  SETTINGS_LANG_LI: 'settings_lang_li',
  SETTINGS_LANG_LN: 'settings_lang_ln',
  SETTINGS_LANG_LT: 'settings_lang_lt',
  SETTINGS_LANG_LB: 'settings_lang_lb',
  SETTINGS_LANG_LU: 'settings_lang_lu',
  SETTINGS_LANG_LG: 'settings_lang_lg',
  SETTINGS_LANG_MH: 'settings_lang_mh',
  SETTINGS_LANG_ML: 'settings_lang_ml',
  SETTINGS_LANG_MR: 'settings_lang_mr',
  SETTINGS_LANG_MK: 'settings_lang_mk',
  SETTINGS_LANG_MG: 'settings_lang_mg',
  SETTINGS_LANG_MT: 'settings_lang_mt',
  SETTINGS_LANG_MN: 'settings_lang_mn',
  SETTINGS_LANG_MI: 'settings_lang_mi',
  SETTINGS_LANG_MS: 'settings_lang_ms',
  SETTINGS_LANG_MY: 'settings_lang_my',
  SETTINGS_LANG_NA: 'settings_lang_na',
  SETTINGS_LANG_NV: 'settings_lang_nv',
  SETTINGS_LANG_NR: 'settings_lang_nr',
  SETTINGS_LANG_ND: 'settings_lang_nd',
  SETTINGS_LANG_NG: 'settings_lang_ng',
  SETTINGS_LANG_NE: 'settings_lang_ne',
  SETTINGS_LANG_NL: 'settings_lang_nl',
  SETTINGS_LANG_NN: 'settings_lang_nn',
  SETTINGS_LANG_NB: 'settings_lang_nb',
  SETTINGS_LANG_NO: 'settings_lang_no',
  SETTINGS_LANG_NY: 'settings_lang_ny',
  SETTINGS_LANG_OC: 'settings_lang_oc',
  SETTINGS_LANG_OJ: 'settings_lang_oj',
  SETTINGS_LANG_OR: 'settings_lang_or',
  SETTINGS_LANG_OM: 'settings_lang_om',
  SETTINGS_LANG_OS: 'settings_lang_os',
  SETTINGS_LANG_PA: 'settings_lang_pa',
  SETTINGS_LANG_PI: 'settings_lang_pi',
  SETTINGS_LANG_PL: 'settings_lang_pl',
  SETTINGS_LANG_PT: 'settings_lang_pt',
  SETTINGS_LANG_PS: 'settings_lang_ps',
  SETTINGS_LANG_QU: 'settings_lang_qu',
  SETTINGS_LANG_RM: 'settings_lang_rm',
  SETTINGS_LANG_RO: 'settings_lang_ro',
  SETTINGS_LANG_RN: 'settings_lang_rn',
  SETTINGS_LANG_RU: 'settings_lang_ru',
  SETTINGS_LANG_SG: 'settings_lang_sg',
  SETTINGS_LANG_SA: 'settings_lang_sa',
  SETTINGS_LANG_SI: 'settings_lang_si',
  SETTINGS_LANG_SK: 'settings_lang_sk',
  SETTINGS_LANG_SL: 'settings_lang_sl',
  SETTINGS_LANG_SE: 'settings_lang_se',
  SETTINGS_LANG_SM: 'settings_lang_sm',
  SETTINGS_LANG_SN: 'settings_lang_sn',
  SETTINGS_LANG_SD: 'settings_lang_sd',
  SETTINGS_LANG_SO: 'settings_lang_so',
  SETTINGS_LANG_ST: 'settings_lang_st',
  SETTINGS_LANG_ES: 'settings_lang_es',
  SETTINGS_LANG_SQ: 'settings_lang_sq',
  SETTINGS_LANG_SC: 'settings_lang_sc',
  SETTINGS_LANG_SR: 'settings_lang_sr',
  SETTINGS_LANG_SS: 'settings_lang_ss',
  SETTINGS_LANG_SU: 'settings_lang_su',
  SETTINGS_LANG_SW: 'settings_lang_sw',
  SETTINGS_LANG_SV: 'settings_lang_sv',
  SETTINGS_LANG_TY: 'settings_lang_ty',
  SETTINGS_LANG_TA: 'settings_lang_ta',
  SETTINGS_LANG_TT: 'settings_lang_tt',
  SETTINGS_LANG_TE: 'settings_lang_te',
  SETTINGS_LANG_TG: 'settings_lang_tg',
  SETTINGS_LANG_TL: 'settings_lang_tl',
  SETTINGS_LANG_TH: 'settings_lang_th',
  SETTINGS_LANG_TI: 'settings_lang_ti',
  SETTINGS_LANG_TO: 'settings_lang_to',
  SETTINGS_LANG_TN: 'settings_lang_tn',
  SETTINGS_LANG_TS: 'settings_lang_ts',
  SETTINGS_LANG_TK: 'settings_lang_tk',
  SETTINGS_LANG_TR: 'settings_lang_tr',
  SETTINGS_LANG_TW: 'settings_lang_tw',
  SETTINGS_LANG_UG: 'settings_lang_ug',
  SETTINGS_LANG_UK: 'settings_lang_uk',
  SETTINGS_LANG_UR: 'settings_lang_ur',
  SETTINGS_LANG_UZ: 'settings_lang_uz',
  SETTINGS_LANG_VE: 'settings_lang_ve',
  SETTINGS_LANG_VI: 'settings_lang_vi',
  SETTINGS_LANG_VO: 'settings_lang_vo',
  SETTINGS_LANG_WA: 'settings_lang_wa',
  SETTINGS_LANG_WO: 'settings_lang_wo',
  SETTINGS_LANG_XH: 'settings_lang_xh',
  SETTINGS_LANG_YI: 'settings_lang_yi',
  SETTINGS_LANG_YO: 'settings_lang_yo',
  SETTINGS_LANG_ZA: 'settings_lang_za',
  SETTINGS_LANG_ZH: 'settings_lang_zh',
  SETTINGS_LANG_ZU: 'settings_lang_zu',
  SEL_CBOX_C_ALL: 'sel_cbox_c_all',
  SEL_CBOX_UC_ALL: 'sel_cbox_uc_all',

  EMAIL_CONFIRMATION_SUCCESS_MESSAGE: 'email_confirmation_success_message',

  MENU_LABEL_HOME: 'menu_label_home',
  MENU_LABEL_ORDERS: 'menu_label_orders',
  MENU_LABEL_MY_TEAMS: 'menu_label_my_teams',
  MENU_LABEL_WORKERS_MAP: 'menu_label_workers_map',
  MENU_LABEL_PILOT_POINTS: 'menu_label_pilot_points',
  MENU_LABEL_PUBLIC_PROFILE: 'menu_label_public_profile',
  MENU_LABEL_SETTINGS: 'menu_label_settings',
  MENU_LABEL_PAYMENT_METHODS: 'menu_label_payment_methods',
  MENU_LABEL_REPORTS: 'menu_label_reports',
  MENU_LABEL_TERMS: 'menu_label_terms',
  MENU_LABEL_LOGOUT: 'menu_label_logout',
  MENU_LABEL_CV: 'menu_label_cv',
  MENU_LABEL_SUPPORT: 'menu_label_support',
  MENU_LABEL_MODE_ORDERER: 'menu_label_mode_orderer',
  MENU_LABEL_MODE_WORKER: 'menu_label_mode_worker',
  MENU_LABEL_SWITCH_SERVICE: 'menu_label_switch_service',
  MENU_LABEL_SERVICE_ADMIN: 'menu_label_service_admin',
  MENU_NO_CONTENT: 'menu_no_content',
  MENU_LABEL_PERSONALINFO: 'menu_label_personalinfo',
  MENU_LABEL_TASKINTERESTS: 'menu_label_taskinterests',
  MENU_LABEL_ACCOMPLISHMENTS: 'menu_label_accomplishments',
  MENU_LABEL_EXPERIENCES: 'menu_label_experiences',
  MENU_LABEL_SELECTLANG: 'menu_label_selectlang',
  MENU_LABEL_INVITE: 'menu_label_invite',

  SETTINGS_LABEL_BANK_ACC: 'settings_label_bank_acc',
  SETTINGS_LABEL_TAX: 'settings_label_tax',
  SETTINGS_LABEL_SSN: 'settings_label_ssn',
  SETTINGS_LABEL_WORKER_TYPE: 'settings_label_worker_type',
  SETTINGS_LABEL_SHORT_DESC: 'settings_label_short_desc',
  SETTINGS_LABEL_VIDEO_PRES: 'settings_label_video_pres',
  SETTINGS_LABEL_ORGANIZATION: 'settings_label_organization',
  SETTINGS_LABEL_COMPANY: 'settings_label_company',
  SETTINGS_LABEL_CV: 'settings_label_cv',
  SETTINGS_LABEL_CHANGE_PW: 'settings_label_change_pw',
  SETTINGS_LABEL_UPLOAD_IMG: 'settings_label_upload_img',
  SETTINGS_LABEL_UPDATE: 'settings_label_update',
  SETTINGS_LABEL_UPDATE_DIALOG: 'settings_label_update_dialog',
  SETTINGS_LABEL_UNLIMITED_DIST: 'settings_label_unlimited_dist',
  SETTINGS_LABEL_VIRTUAL_ADDR: 'settings_label_virtual_addr',
  SETTINGS_LABEL_DISTANCE: 'settings_label_distance',
  TXT_SELECT_ALL: 'txt_select_all',
  SETTINGS_LABEL_SELECT_TASK_TYPE: 'settings_label_select_task_type',
  SETTINGS_LABEL_PROFICIENCY: 'settings_label_proficiency',
  SETTINGS_LABEL_NO_EDU_ADDED: 'settings_label_no_edu_added',
  SETTINGS_LABEL_NO_LANG_ADDED: 'settings_label_no_lang_added',
  SETTINGS_LABEL_ADD_LANG: 'settings_label_add_lang',
  SETTINGS_LABEL_ADD_EDU: 'settings_label_add_edu',

  SETTINGS_LABEL_TYPE: 'settings_label_type',
  SETTINGS_LABEL_TITLE: 'settings_label_title',
  SETTINGS_LABEL_WHERE: 'settings_label_where',
  SETTINGS_LABEL_COMPLETED_YEAR: 'settings_label_completed_year',
  SETTINGS_LABEL_COMPLETED_MONTH: 'settings_label_completed_month',
  SETTINGS_LABEL_CURRENT: 'settings_label_current',
  SETTINGS_LABEL_DELETE: 'settings_label_delete',
  SETTINGS_LABEL_LANG_AR: 'settings_label_lang_ar',
  SETTINGS_LABEL_LANG_EN: 'settings_label_lang_en',
  SETTINGS_LABEL_LANG_FA: 'settings_label_lang_fa',
  SETTINGS_LABEL_LANG_FI: 'settings_label_lang_fi',
  SETTINGS_LABEL_LANG_RU: 'settings_label_lang_ru',
  SETTINGS_LABEL_LANG_SV: 'settings_label_lang_sv',
  SETTINGS_LABEL_MONTH_JAN: 'settings_label_month_jan',
  SETTINGS_LABEL_MONTH_FEB: 'settings_label_month_feb',
  SETTINGS_LABEL_MONTH_MAR: 'settings_label_month_mar',
  SETTINGS_LABEL_MONTH_APR: 'settings_label_month_apr',
  SETTINGS_LABEL_MONTH_MAY: 'settings_label_month_may',
  SETTINGS_LABEL_MONTH_JUN: 'settings_label_month_jun',
  SETTINGS_LABEL_MONTH_JUL: 'settings_label_month_jul',
  SETTINGS_LABEL_MONTH_AUG: 'settings_label_month_aug',
  SETTINGS_LABEL_MONTH_SEP: 'settings_label_month_sep',
  SETTINGS_LABEL_MONTH_OCT: 'settings_label_month_oct',
  SETTINGS_LABEL_MONTH_NOV: 'settings_label_month_nov',
  SETTINGS_LABEL_MONTH_DEC: 'settings_label_month_dec',
  SETTINGS_LABEL_TOOLTIP_EXP: 'settings_label_tooltip_exp',
  SETTINGS_LABEL_NO_EXP_ADDED: 'settings_label_no_exp_added',
  SETTINGS_LABEL_ADD_EXP: 'settings_label_add_exp',
  SETTINGS_LABEL_POSITION: 'settings_label_position',
  SETTINGS_LABEL_START_MONTH: 'settings_label_start_month',
  SETTINGS_LABEL_START_YEAR: 'settings_label_start_year',
  SETTINGS_LABEL_END_MONTH: 'settings_label_end_month',
  SETTINGS_LABEL_END_YEAR: 'settings_label_end_year',
  SETTINGS_LABEL_DESCRIPTION: 'settings_label_description',
  SETTINGS_LABEL_VIDEO: 'settings_label_video',
  SETTINGS_LABEL_EDIT_EXP: 'settings_label_edit_exp',
  SETTINGS_LABEL_SAVED: 'settings_label_saved',
  SETTINGS_LABEL_EDIT_LANG: 'settings_label_edit_lang',
  SETTINGS_LABEL_EDIT_EDU: 'settings_label_edit_edu',
  SETTINGS_INVALID_BANK: 'settings_invalid_bank',
  SETTINGS_INVALID_SSN: 'settings_invalid_ssn',
  SETTINGS_INVALID_VIDEO: 'settings_invalid_video',
  SETTINGS_INVALID_LINKEDIN: 'settings_invalid_linkedin',
  SETTINGS_INVALID_TAX: 'settings_invalid_tax',

  LOGIN_LABEL_EMAIL: 'login_label_email',
  LOGIN_LABEL_PASSWORD: 'login_label_password',
  LOGIN_LABEL_LOGIN: 'login_label_login',
  LOGIN_LABEL_FORGOT_PASSWORD: 'login_label_forgot_password',
  LOGIN_LABEL_RESET_PASSWORD: 'login_label_reset_password',
  LOGIN_LABEL_RESET_MESSAGE: 'login_label_reset_message',
  LOGIN_LABEL_RESEND_CONFIRMATION: 'login_label_resend_confirmation',
  LOGIN_LABEL_RESEND_TITLE: 'login_label_resend_title',
  LOGIN_LABEL_RESEND_MESSAGE: 'login_label_resend_message',
  LOGIN_FORM_WELCOME: 'login_form_welcome',
  LOGIN_FORM_SIGN_IN: 'login_form_sign_in',
  LOGIN_FORM_FORGOT_PASSWORD: 'login_form_forgot_password',
  LOGIN_FORM_CLOSE: 'login_form_close',
  LOGIN_FORM_SEND: 'login_form_send',
  WORKER_COMPANY_REGISTRATION_NUMBER: 'worker_company_registration_number',
  SETTINGS_INVALID_FIRST_NAME: 'settings_invalid_first_name',
  SETTINGS_INVALID_LAST_NAME: 'settings_invalid_last_name',
  SETTINGS_LABEL_TOOLTIP_LANG: 'settings_label_tooltip_lang',
  SETTINGS_LABEL_TOOLTIP_EDU: 'settings_label_tooltip_edu',
  SETTINGS_LABEL_INVALID_IMG: 'settings_label_invalid_img',
  SETTINGS_LABEL_INVALID_COMP_NAME: 'settings_label_invalid_comp_name',
  SETTINGS_LABEL_INVALID_REG_NUM: 'settings_label_invalid_reg_num',
  SETTINGS_LABEL_CHANGE_PIC: 'settings_label_change_pic',
  SETTINGS_LABEL_EDIT_PROF: 'settings_label_edit_prof',
  ORDER_LIST_MESSAGE_CANCEL: 'order_list_message_cancel',
  ORDER_LIST_MESSAGE_COMPLETE: 'order_list_message_complete',
  ORDER_LIST_MESSAGE_APPLY: 'order_list_message_apply',
  ORDER_LIST_MESSAGE_APPROVE: 'order_list_message_approve',
  SWITCH_MERCHANT_REGISTERED: 'switch_merchant_registered',

  REGISTER_LABEL_CREATE_ACCOUNT: 'register_label_create_account',
  REGISTER_LABEL_LANGUAGE: 'register_label_language',
  REGISTER_LABEL_SELECT_LANGUAGE: 'register_label_select_language',
  REGISTER_LABEL_FIRST_NAME: 'register_label_first_name',
  REGISTER_LABEL_LAST_NAME: 'register_label_last_name',
  REGISTER_LABEL_PASSWORD_CONFIRM: 'register_label_password_confirm',
  REGISTER_LABEL_REGISTER: 'register_label_register',
  REGISTER_LABEL_ALREADY: 'register_label_already',
  REGISTER_LABEL_SUCCESS: 'register_label_success',
  REGISTER_LABEL_TOU: 'register_label_tou',
  REGISTER_MESSAGE_SUCCESS: 'register_message_success',
  REG_FORM_OK: 'reg_form_ok',
  LOGINREG_LINK_TO_REGISTRATION: 'loginreg_link_to_registration',
  LOGINREG_LINK_TO_LOGIN: 'loginreg_link_to_login',
  REGISTER_TOOLTIP_PRIVATE_MERCHANT: 'register_tooltip_private_merchant',
  REGISTER_TOOLTIP_PUBLIC_MERCHANT: 'register_tooltip_public_merchant',
  REGISTER_MESSAGE_ACCEPT_TOU: 'reg_accept_tou',

  CHANGE_PASSWORD_FORM_TITLE: 'change_password_form_title',
  CHANGE_PASSWORD_OLD_PASSWORD_LABEL: 'change_password_old_password_label',
  CHANGE_PASSWORD_NEW_PASSWORD_LABEL: 'change_password_new_password_label',
  CHANGE_PASSWORD_SUBMIT_LABEL: 'change_password_submit_label',
  CHANGE_PASSWORD_CANCEL_LABEL: 'change_password_cancel_label',
  CHANGE_PASSWORD_SUCCESS_MESSAGE: 'change_password_success_message',

  RESET_PASSWORD_FORM_TITLE: 'reset_password_form_title',
  RESET_PASSWORD_PASSWORD_LABEL: 'reset_password_password_label',
  RESET_PASSWORD_CONFIRM_PASSWORD_LABEL:
    'reset_password_confirm_password_label',
  RESET_PASSWORD_SUBMIT_LABEL: 'reset_password_submit_label',
  RESET_PASSWORD_CANCEL_LABEL: 'reset_password_cancel_label',
  RESET_PASSWORD_NO_TOKEN_MESSAGE: 'reset_password_no_token_message',
  RESET_PASSWORD_SUCCESS_MESSAGE: 'reset_password_success_message',

  FIRST_TIME_TITLE: 'first_time_title',
  FIRST_TIME_CONTENT_1: 'first_time_content_1',
  FIRST_TIME_CONTENT_2: 'first_time_content_2',
  FIRST_TIME_ORDERER_BUTTON_LABEL: 'first_time_orderer_button_label',
  FIRST_TIME_WORKER_BUTTON_LABEL: 'first_time_worker_button_label',

  MERCHANT_LABEL_SERVICE: 'merchant_label_service',
  MERCHANT_LABEL_SELECT_SERVICE: 'merchant_label_select_service',
  MERCHANT_LABEL_PRIVATE_SERVICE: 'merchant_label_private_service',
  MERCHANT_LABEL_PRIVATE_CODE: 'merchant_label_private_code',
  MERCHANT_LABEL_PRIVATE_NAME: 'merchant_label_private_name',
  MERCHANT_NO_SERVICE_DESCRIPTION: 'register_private_service_about_to',

  PHONE_NUMBER_LABEL: 'phone_number_label',
  PHONE_AREA_CODE: 'phone_area_code',

  NATIVE_SELECT_TYPE_TEXT: 'native_select_type_text',
  NATIVE_SELECT_START_TYPE_TEXT: 'native_select_start_type_text',

  NOTIFICATION_MESSAGE_EMPTY: 'notification_message_empty',
  PUSH_INVITED_TO_MERCHANT: 'push_invited_to_merchant',
  INVITE_YOU_HAVE_BEEN_INVITED: 'invite_you_have_been_invited',
  INVITE_WITH_COMMENT: 'invite_with_comment',

  TABLE_NO_RESULT: 'table_no_result',
  TABLE_BUTTON_PREV: 'table_button_prev',
  TABLE_BUTTON_NEXT: 'table_button_next',

  TABLE_CHIP_UNASSIGNED: 'table_chip_unassigned',
  TABLE_CHIP_IN_PROG: 'table_chip_in_prog',
  TABLE_CHIP_AW_APPR: 'table_chip_aw_appr',
  TABLE_CHIP_HIST: 'table_chip_hist',
  TABLE_CHIP_OPPS: 'table_chip_opps',
  TABLE_HEADER_TASK: 'table_header_task',
  TABLE_HEADER_INIT_TIME: 'table_header_init_time',
  TABLE_HEADER_AMOUNT: 'table_header_amount',
  TABLE_HEADER_PRICE: 'table_header_price',
  TABLE_HEADER_LOCATION: 'table_header_location',
  TABLE_HEADER_APPS: 'table_header_apps',
  TABLE_HEADER_STATUS: 'table_header_status',
  TABLE_HEADER_RATING: 'table_header_rating',
  TABLE_HEADER_CHAT: 'table_header_chat',
  TABLE_HEADER_APPLY: 'table_header_apply',
  TABLE_COLOR_CANC: 'table_color_canc',
  TABLE_SEARCH_FIELD: 'table_search_field',
  TABLE_BUTTON_CREATE: 'table_button_create',

  HOME_HEXA_PEND: 'home_hexa_pend',
  HOME_HEXA_AWAIT: 'home_hexa_await',
  HOME_HEXA_APPRV: 'home_hexa_apprv',
  HOME_HEXA_AMOUNT: 'home_hexa_amount',
  HOME_HEXA_FORYOU: 'home_hexa_foryou',
  HOME_HEXA_PAYMENTS: 'home_hexa_payments',
  HOME_HEXA_AND_REPORTS: 'home_hexa_and_reports',
  HOME_BUTTON_NEW: 'home_button_new',

  SERVICE_SWITCHER_REGISTERED: 'service_switcher_registered',
  SERVICE_SWITCHER_ANOTHER_BTN: 'service_switcher_another_btn',
  SERVICE_SWTICHER_ANOTHER_DESC: 'service_switcher_another_desc',
  SERVICE_SWITCHER_TOU_BY: 'service_switcher_tou_by',
  SERVICE_SWITCHER_TOU_TOU: 'service_switcher_tou_tou',
  SERVICE_SWITCHER_TOU_OS: 'service_switcher_tou_os',

  NOTIFICATION_DIFFERENT_SERVICE_LABEL: 'notification_different_service_label',
  NOTIFICATION_DIFFERENT_SERVICE_TEXT: 'notification_different_service_text',
  NOTIFICATIONS_INVITATION_TO_SERVICE: 'notifications_invitation_to_service',
  NOTIFICATIONS_RELEASE_NOTES_TEXT: 'notifications_release_notes_text',
  NOTIFICATIONS_TASK_NOT_AVAILABLE: 'notifications_task_not_available',
  NOTIFICATIONS_TITLE: 'notifications_title',

  SWITCHER_DIALOG_CONTENT_FIRST: 'switcher_dialog_content_first',
  SWITCHER_DIALOG_CONTENT_LAST: 'switcher_dialog_content_last',

  ERROR_LOGIN_NEEDS_APPROVAL: 'error_login_needs_approval',
  DIALOG_TITLE_UNKNOWN_ERROR: 'dialog_title_unknown_error',
  ORDER_NEW_TIME_ERROR_MINIMUM: 'order_new_time_error_minimum',
  ORDER_NEW_TIME_ERROR_INCREMENT: 'order_new_time_error_increment',
  NEW_ORDER_HEADER_DESC: 'new_order_header_desc',
  NEW_ORDER_HEADER_LOC: 'new_order_header_loc',
  NEW_ORDER_HEADER_TIME: 'new_order_header_time',
  NEW_ORDER_HEADER_PAY: 'new_order_header_pay',
  NEW_ORDER_HEADER_SUM: 'new_order_header_sum',
  NEW_ORDER_VIEW_TEXT: 'Orderer view',
  NEW_ORDER_NEW_TEXT: 'New order',
  NEW_ORDER_CATEGORY_HWORK: 'Housework',
  NEW_ORDER_CATEGORY_TRANSP: 'Transport',
  NEW_ORDER_CATEGORY_CARING: 'Caring for others',
  NEW_ORDER_LABEL_ENTER_TASK: 'new_order_label_enter_task',
  NEW_ORDER_LABEL_TEMPLATES: 'Templates',
  NEW_ORDER_LABEL_PICK: 'new_order_label_pick',
  NEW_ORDER_LABEL_ADD_INFO: 'new_order_label_add_info',
  NEW_ORDER_LABEL_ADD_TEAM_CODE: 'new_order_label_add_team_code',
  NEW_ORDER_NOT_EN_PP: 'new_order_not_en_pp',
  NEW_ORDER_LOC_REGION: 'new_order_loc_region',
  NEW_ORDER_SUM_NEWORDER: 'new_order_sum_neworder',
  NEW_ORDER_SUM_PUBLISH: 'new_order_sum_publish',
  NEW_ORDER_SUM_TASKDESC: 'new_order_sum_taskdesc',
  NEW_ORDER_SUM_TYPE: 'new_order_sum_type',
  NEW_ORDER_SUM_TEAMS: 'new_order_sum_teams',
  NEW_ORDER_SUM_PRIVTEAM: 'new_order_sum_privteam',
  NEW_ORDER_SUM_AMOUNT: 'new_order_sum_amount',
  NEW_ORDER_SUM_PAYMENT: 'new_order_sum_payment',
  NEW_ORDER_SUM_PRICE: 'new_order_sum_price',
  NEW_ORDER_SUM_VAT: 'new_order_sum_vat',
  NEW_ORDER_SUM_TOTAL: 'new_order_sum_total',
  NEW_ORDER_PUBLISH: 'new_order_publish',
  NEW_ORDER_SUM_W_EM: 'new_order_sum_w_em',
  NEW_ORDER_DESC_NOTEAMS: 'new_order_desc_noteams',
  NEW_ORDER_DESC_TEAMNAME: 'new_order_desc_teamname',
  NEW_ORDER_DESC_WORKERNAME: 'new_order_desc_workername',
  NEW_ORDER_TARGET_LABEL: 'new_order_target_label',

  ORDER_APPLY_TASK: 'order_apply_task',
  ORDER_SHARE: 'order_share',
  ORDER_STATUS: 'order_status',
  ORDER_CANCEL: 'order_cancel',
  ORDER_CANCEL_CONFIRM: 'order_cancel_confirm',
  ORDER_APPLY_CONFIRM: 'order_apply_confirm',
  ORDER_APPLY_WITHOUT_APPLICATION: 'order_apply_without_application',
  ORDER_CANCEL_APPL: 'order_cancel_appl',
  ORDER_COPY: 'order_copy',
  ORDER_EDIT: 'order_edit',
  ORDER_BROWSE_APPL: 'order_browse_appl',
  ORDER_TASK_COMPLETE: 'order_task_complete',
  ORDER_APPROVE: 'order_approve',
  ORDER_NOT_APPROVE: 'order_not_approve',
  ORDER_SHOW_RCPT: 'order_show_rcpt',
  ORDER_GET_CERT: 'order_get_cert',
  ORDER_GET_PAYM_DET: 'order_get_paym_det',
  ORDER_RATE_ORDERER: 'order_rate_orderer',
  ORDER_RATE_WORKER: 'order_rate_worker',
  ORDER_CONF_TIME: 'order_conf_time',
  ORDER_FEEDBACK_TEXT: 'order_feedback_text',
  ORDER_CHOOSE_RAT: 'order_choose_rat',
  ORDER_SHORT_COMMENT: 'order_short_comment',
  ORDER_SUBMIT: 'order_submit',
  ORDER_NO_APPLS: 'order_no_appls',
  ORDER_CERT_ADD: 'order_cert_add',
  ORDER_ADD_FBACK: 'order_add_fback',
  ORDER_ADD_FBACK_DONT: 'order_add_fback_dont',
  ORDER_CERT_DOWNL: 'order_cert_downl',
  ORDER_DATE: 'order_date',
  ORDER_NAME: 'order_name',
  ORDER_COMPL_JOBS: 'order_compl_jobs',
  ORDER_WORK_INFO: 'order_work_info',
  ORDER_OWN_DESC: 'order_own_desc',
  ORDER_HIDE_USER: 'order_hide_user',
  ORDER_SUCCESSFULL_WORKER_SELECTION: 'order_successfull_worker_selection',
  ORDER_VIEW_PROFILE: 'order_view_profile',
  TXT_SELECT: 'txt_select',
  ORDER_COPIED_LINK: 'order_copied_link',
  TXT_COPY_LINK: 'txt_copy_link',
  ORDER_TASK_DESC: 'order_task_desc',
  ORDER_TEAMS: 'order_teams',
  ORDER_COMPLETED_TXT: 'order_completed_txt',
  ORDER_EARNING: 'order_earning',
  ORDER_VAT: 'order_vat',
  ORDER_LABEL_PUBLISHED: 'order_label_published',
  ORDER_SHOW_ON_MAP: 'order_show_on_map',
  ORDER_TASK_LOC: 'order_task_loc',
  ORDER_DESCR_WORKER: 'order_descr_worker',
  ORDER_DESCR_ORDERER: 'order_descr_orderer',
  ORDER_WORKER_COMMS: 'order_worker_comms',
  ORDER_HIDE_USER_CONTENT: 'order_hide_user_content',
  ORDER_MORE_APPL: 'order_more_appl',
  ORDER_NO_ONLY_ONE: 'order_no_only_one',
  ORDER_SELECT_APPL: 'order_select_appl',
  ORDER_SHOW_HWORKERS: 'order_show_hworkers',
  ORDER_HIDE_HWORKERS: 'order_hide_hworkers',
  ORDER_YOUR_COMMENT_LABEL: 'order_your_comment_label',
  SHARE_INORDER: 'share_inorder',
  SHARE_USEMOB: 'share_usemob',
  ORDERS_IS_VIRTUAL: 'orders_is_virtual',
  ORDERS_IS_VIRTUAL_CBOX: 'orders_is_virtual_cbox',
  ORDER_UNHIDE_USER: 'order_unhide_user',
  ORDER_UNHIDE_USER_CONTENT: 'order_unhide_user_content',
  LABEL_ORDER: 'label_order',
  ORDER_LABEL_EDIT: 'order_label_edit',
  ORDER_LABEL_COPY: 'order_label_copy',
  ORDER_EDIT_BACK: 'order_edit_back',
  ORDER_ACC_REF: 'order_acc_ref',
  TXT_NO: 'txt_no',
  ORDER_COPY_WORKER: 'order_copy_worker',
  ORDER_WORKER_TEAM_INVALID: 'order_worker_team_invalid',
  ORDER_COPY_SIMPLE: 'order_copy_simple',
  CV_SHARE: 'cv_share',
  CV_LABEL_COMPLETED_GIGS: 'cv_label_completed_gigs',
  CV_SHOW_ALL_FEEDBACK: 'cv_show_all_feedback',
  CV_HIDE_ALL_FEEDBACK: 'cv_hide_all_feedback',
  SAVE_CV_COLORS: 'save_cv_colors',
  SAVE_CV_COLORS_FAILURE: 'save_cv_colors_fail',
  SAVE_CV_COLORS_SUCCESS: 'save_cv_colors_success',
  CV_SWITCH_TOOLTIP: 'cv_switch_tooltip',
  CV_EDUCATION_AND_CERTIFICATES: 'cv_education_and_certificates',
  CV_ABOUT_ME: 'cv_about_me',
  CV_LANGUAGES: 'cv_languages',
  CV_MY_EXPERIENCES: 'cv_my_experiences',
  CV_WORKED_FIELDS: 'cv_worked_fields',
  CV_WORKED_TIMES: 'cv_worked_times',
  CV_NO_COMPLETED_TASKS_YET: 'cv_no_completed_tasks_yet',
  CV_PRINT_LABEL: 'cv_print_label',
  CV_CURRENT: 'cv_current',
  CV_CHANGE_THEMES: 'cv_change_themes',
  CV_CUSTOMISE_BACKGROUND_COLOR: 'cv_customise_background_color',
  CV_SHARE_MERCHANT_COLOR: 'cv_share_merchant_color',

  SETTINGS_EXP_DIALOG_DATE_INVALID: 'settings_exp_dialog_date_invalid',
  SETTINGS_UNSAVED_CHANGES: 'settings_unsaved_changes',
  SETTINGS_DO_YOU_WANT_TO_SAVE: 'settings_do_you_want_to_save',
  SHARED_ORDER_TASK_LABEL: 'shared_order_task_label',
  SHARED_ORDER_TYPE_LABEL: 'shared_order_type_label',
  SHARED_ORDER_TIME_LABEL: 'shared_order_time_label',
  SHARED_ORDER_LOCATION_LABEL: 'shared_order_location_label',
  SHARED_ORDER_AMOUNT_LABEL: 'shared_order_amount_label',
  SHARED_ORDER_EARNING_LABEL: 'shared_order_earning_label',
  SHARED_ORDER_ADD_INFO_LABEL: 'shared_order_add_info_label',
  SHARED_ORDER_LOGIN_TEXT: 'shared_order_login_text',
  SHARED_ORDER_MORE_INFO_TEXT: 'shared_order_more_info_text',
  SHARED_ORDER_USE_APP_TEXT: 'shared_order_use_app_text',

  RECEIPT_DATE: 'receipt_date',
  RECEIPT_ID: 'receipt_id',
  RECEIPT_MERCHANT: 'receipt_merchant',
  RECEIPT_VAT_NUM: 'receipt_vat_num',
  RECEIPT_ORDERER: 'receipt_orderer',
  RECEIPT_ORD_SERVICE: 'receipt_ord_service',
  RECEIPT_CONF_TIME: 'receipt_conf_time',
  RECEIPT_INIT_TIME: 'receipt_init_time',
  RECEIPT_LABEL: 'receipt_label',

  WORKER_MAP_SECURITY: 'worker_map_security',

  SUPPORT_MESSAGES: 'support_messages', // Messages
  SUPPORT_TASKS: 'support_tasks', // Tasks
  SUPPORT_ENTER_MESSAGE: 'support_enter_message', // Please, enter message
  SUPPORT_NO_CHATS: 'support_no_chats', // No chats
  SUPPORT_NO_MESSAGES: 'support_no_messages', // No messages
  SUPPORT_SEARCH: 'support_search', // Pikaohje

  PROFILE_PUBLIC_SHARING_NOT_ALLOWED_TITLE:
    'profile_public_sharing_not_allowed_title',
  PROFILE_PUBLIC_SHARING_NOT_ALLOWED_MESSAGE:
    'profile_public_sharing_not_allowed_message',
  PROFILE_WORKER_INFO_LABEL: 'profile_worker_info_label',
  PROFILE_DESCRIPTION_LABEL: 'profile_description_label',
  PROFILE_CITY_LABEL: 'profile_city_label',
  PROFILE_POSTAL_CODE_LABEL: 'profile_postal_code_label',
  PROFILE_EMAIL_LABEL: 'profile_email_label',
  PROFILE_PHONE_NUMBER_LABEL: 'profile_phone_number_label',
  PROFILE_COMPLETED_ORDERS_LABEL: 'profile_completed_orders_label',
  PROFILE_COMPLETED_TASKS_LABEL: 'profile_completed_tasks_label',
  PROFILE_RATING_LABEL: 'profile_overall_rating_label',
  PROFILE_AVAILABLE_FOR_LABEL: 'profile_available_for_label',
  PROFILE_CV_LINK_LABEL: 'profile_cv_link_label',
  PROFILE_CV_LINK_TEXT: 'profile_cv_link_text',
  PROFILE_LINKEDIN_LINK_LABEL: 'profile_linkedin_link_label',
  PROFILE_REFEREE_LABEL: 'profile_referee_label',
  PROFILE_LINKEDIN_LINK_TEXT: 'profile_linkedin_link_text',
  PROFILE_ONLY_FOR_WORKER_TEXT: 'profile_only_for_worker_text',
  PROFILE_COMPAMY_LABEL: 'profile_compamy_label',
  PROFILE_NO_MESSAGE: 'profile_no_message',
  PROFILE_AVAIL_AFTER_WORKER_SELECTED: 'profile_avail_after_worker_selected',

  DOCUMENTS_TOOLTIP: 'documents_tooltip',
  DOCUMENTS_NAME: 'documents_name',
  DOCUMENTS_NAME_HEADER: 'documents_name_header',
  DOCUMENTS_INFO_HEADER: 'documents_info_header',
  DOCUMENTS_DELETE: 'documents_delete',
  DOCUMENTS_ADD: 'documents_add',
  DOCUMENTS_EDIT: 'documents_edit',
  DOCUMENTS_DIALOG_TOOLTIP: 'documents_dialog_tooltip',
  DOCUMENTS_ADD_PHOTO: 'documents_add_photo',
  DOCUMENTS_ADD_MESSAGE: 'documents_add_message',
  DOCUMENTS_ADD_TYPE: 'documents_add_type',

  FEEDBACK_LIST_TITLE_ORDERER: 'feedback_list_title_orderer',
  FEEDBACK_LIST_TITLE_WORKER: 'feedback_list_title_worker',
  FEEDBACK_LIST_TODAY_LABEL: 'feedback_list_today_label',
  FEEDBACK_LIST_NO_COMMENT_TEXT: 'feedback_list_no_comment_text',
  FEEDBACK_LIST_LOAD_MORE_LABEL: 'feedback_list_load_more_label',
  FEEDBACK_SHOWING_ALL_COMMENTS: 'feedback_showing_all_comments',

  PILOT_POINTS_PILOTPOINTS: 'pilot_points_pilotpoints',
  PILOT_POINTS_SAVE: 'pilot_points_save',
  PILOT_POINTS_CANCEL: 'pilot_points_cancel',
  PILOT_POINTS_BUY_LINK_LABEL: 'pilot_points_buy_link_label',
  PILOT_POINTS_DONATE_LINK_LABEL: 'pilot_points_donate_link_label',
  PILOT_POINTS_CLAIM_LINK_LABEL: 'pilot_points_claim_link_label',
  PILOT_POINTS_HISTORY_LINK_LABEL: 'pilot_points_history_link_label',

  PILOT_POINTS_BUY_FORM_TITLE: 'pilot_points_buy_form_title',
  PILOT_POINTS_BUY_EXPLANATION_LINE1: 'pilot_points_buy_explanation_line1',
  PILOT_POINTS_BUY_EXPLANATION_LINE2: 'pilot_points_buy_explanation_line2',
  PILOT_POINTS_BUY_EXPLANATION_LINE3: 'pilot_points_buy_explanation_line3',
  PILOT_POINTS_BUY_YOUR_PP_LABEL: 'pilot_points_buy_your_pp_label',
  PILOT_POINTS_BUY_BUY_AMOUNT_LABEL: 'pilot_points_buy_buy_amount_label',
  PILOT_POINTS_BUY_BUY_LABEL: 'pilot_points_buy_buy_label',
  PILOT_POINTS_BUY_CONFIRM_TITLE: 'pilot_points_buy_confirm_title',
  PILOT_POINTS_BUY_CONFIRM_YES_LABEL: 'pilot_points_buy_confirm_confirm_label',
  PILOT_POINTS_BUY_CONFIRM_CANCEL_LABEL:
    'pilot_points_buy_confirm_cancel_label',
  PILOT_POINTS_BUY_CONFIRM_TEXT: 'pilot_points_buy_confirm_text',
  PILOT_POINTS_BUY_TOTAL_TEXT: 'pilot_points_buy_total_text',
  PILOT_POINTS_BUY_ERROR_AMOUNT_IS_NAN: 'pilot_points_buy_error_amount_is_nan',
  PILOT_POINTS_BUY_ERROR_AMOUNT_TOO_LOW: 'pilot_points_buy_error_amount_to_low',
  PILOT_POINTS_BUY_SUCCESS_TEXT: 'pilot_points_buy_success_text',
  PILOT_POINTS_BUY_PAYMENT_FAILED: 'pilot_points_buy_payment_failed',

  PILOT_POINTS_DONATE_FORM_TITLE: 'pilot_points_donate_form_title',
  PILOT_POINTS_DONATE_EXPLANATION_LINE1:
    'pilot_points_donate_explanation_line1',
  PILOT_POINTS_DONATE_EXPLANATION_LINE2:
    'pilot_points_donate_explanation_line2',
  PILOT_POINTS_DONATE_EXPLANATION_LINE3:
    'pilot_points_donate_explanation_line3',
  PILOT_POINTS_DONATE_YOUR_PP_LABEL: 'pilot_points_donate_your_pp_label',
  PILOT_POINTS_DONATE_AMOUNT_LABEL: 'pilot_points_donate_amount_label',
  PILOT_POINTS_DONATE_LEAVE_COMMENT_LABEL:
    'pilot_points_donate_leave_comment_label',
  PILOT_POINTS_DONATE_SEND_TO_LABEL: 'pilot_points_donate_send_to_label',
  PILOT_POINTS_DONATE_YOUR_COMMENT_LABEL:
    'pilot_points_donate_your_comment_label',
  PILOT_POINTS_DONATE_EMAIL_LABEL: 'pilot_points_donate_email_label',
  PILOT_POINTS_DONATE_CONFIRM_EMAIL_LABEL:
    'pilot_points_donate_confirm_email_label',
  PILOT_POINTS_DONATE_DONATE_LABEL: 'pilot_points_donate_donate_label',
  PILOT_POINTS_DONATE_CONFIRM_TITLE: 'pilot_points_donate_confirm_title',
  PILOT_POINTS_DONATE_CONFIRM_YES_LABEL:
    'pilot_points_donate_confirm_confirm_label',
  PILOT_POINTS_DONATE_CONFIRM_CANCEL_LABEL:
    'pilot_points_donate_confirm_cancel_label',
  PILOT_POINTS_DONATE_ERROR_DONATE_TO_SELF:
    'pilot_points_donate_error_donate_to_self',
  PILOT_POINTS_DONATE_ERROR_AMOUNT_IS_NAN:
    'pilot_points_donate_error_amount_is_nan',
  PILOT_POINTS_DONATE_ERROR_AMOUNT_TO_HIGH:
    'pilot_points_donate_error_amount_too_high',
  PILOT_POINTS_DONATE_ERROR_AMOUNT_TOO_LOW:
    'pilot_points_donate_error_amount_too_low',
  PILOT_POINTS_DONATE_ERROR_EMAIL_HAS_NO_AT:
    'pilot_points_donate_error_email_has_no_at',
  PILOT_POINTS_DONATE_ERROR_EMAIL_HAS_TOO_MANY_AT:
    'pilot_points_donate_error_email_has_too_many_at',
  PILOT_POINTS_DONATE_ERROR_EMAIL_SHORT_NAME:
    'pilot_points_donate_error_email_short_name',
  PILOT_POINTS_DONATE_ERROR_EMAIL_SHORT_DOMAIN:
    'pilot_points_donate_error_email_short_domain',
  PILOT_POINTS_DONATE_ERROR_EMAIL_CONFIRM_NO_EMAIL:
    'pilot_points_donate_error_email_confirm_no_email',
  PILOT_POINTS_DONATE_ERROR_EMAIL_CONFIRM_WRONG:
    'pilot_points_donate_error_email_confirm_wrong',
  PILOT_POINTS_DONATE_CONFIRM_TEXT: 'pilot_points_donate_confirm_text',
  PILOT_POINTS_DONATE_TOTAL_TEXT: 'pilot_points_donate_total_text',
  PILOT_POINTS_DONATE_SUCCESS_TEXT: 'pilot_points_donate_success_text',

  PILOT_POINTS_CLAIM_FORM_TITLE: 'pilot_points_claim_form_title',
  PILOT_POINTS_CLAIM_EXPLANATION_LINE1: 'pilot_points_claim_explanation_line1',
  PILOT_POINTS_CLAIM_EXPLANATION_LINE2: 'pilot_points_claim_explanation_line2',
  PILOT_POINTS_CLAIM_YOUR_PP_LABEL: 'pilot_points_claim_your_pp_label',
  PILOT_POINTS_CLAIM_INVITATION_CODE_LABEL:
    'pilot_points_claim_invitation_code_label',
  PILOT_POINTS_CLAIM_CLAIM_LABEL: 'pilot_points_claim_claim_label',
  PILOT_POINTS_CLAIM_SUCCESS_TEXT: 'pilot_points_claim_success_text',
  PILOT_POINTS_CLAIM_PROCESSING_TEXT: 'pilot_points_claim_processing_text', // Processing...

  PILOT_POINTS_HISTORY_FORM_TITLE: 'pilot_points_history_form_title',
  PILOT_POINTS_HISTORY_EXPLANATION_LINE:
    'pilot_points_history_explanation_line',
  PILOT_POINTS_HISTORY_TOTAL_LABEL: 'pilot_points_history_total_label',
  PILOT_POINTS_HISTORY_DATE_LABEL: 'pilot_points_history_date_label',
  PILOT_POINTS_HISTORY_TYPE_LABEL: 'pilot_points_history_type_label',
  PILOT_POINTS_HISTORY_PP_LABEL: 'pilot_points_history_pp_label',
  PILOT_POINTS_HISTORY_PRICE_LABEL: 'pilot_points_history_price_label',
  PILOT_POINTS_HISTORY_TRANSACTION_DATA_LABEL:
    'pilot_points_history_transaction_data_label',
  PILOT_POINTS_HISTORY_COMMENT_LABEL: 'pilot_points_history_comment_label',
  PILOT_POINTS_HISTORY_NO_HISTORY_LABEL:
    'pilot_points_history_no_history_label',
  BUTTON_BACK_TO_PAYMENT_AND_REPORTS: 'button_back_to_payment_and_reports',

  PAYMENT_METHOD_SELECTOR_NO_OPTIONS_TEXT:
    'payment_method_selector_no_options_text',
  PAYMENT_METHOD_SELECTOR_ADD_CARD_TEXT:
    'payment_method_selector_add_card_text',
  PAYMENT_METHOD_SELECTOR_SELECT_TEXT: 'payment_method_selector_select_text',
  PAYMENT_METHOD_SELECTOR_CLOSE_LABEL: 'payment_method_selector_close_label',
  PAYMENT_METHOD_SELECTOR_SELECT_LABEL: 'payment_method_selector_select_label',
  PAYMENT_METHOD_SELECTOR_SELECT_PAYMENT_LABEL:
    'payment_method_selector_select_payment_label',
  PAYMENT_PROVIDER_NOT_AVAILABLE_TEXT: 'payment_provider_not_available_text',

  NEW_ORDER_WP_BILLING: 'new_order_wp_billing',
  NEW_ORDER_LOC_INVALID_STR: 'new_order_loc_invalid_str',
  NEW_ORDER_LOC_INVALID_STR_NAME: 'new_order_loc_invalid_str_name',
  NEW_ORDER_LOC_INV_CTRY: 'new_order_loc_inv_ctry',
  NEW_ORDER_LOC_POST: 'new_order_loc_post',
  NEW_ORDER_LOC_ADDR_LINE: 'new_order_loc_addr_line',
  NEW_ORDER_LOC_INV_CORD: 'new_order_loc_inv_cord',
  NEW_ORDER_LOC_NO_RES: 'new_order_loc_no_res',
  NEW_ORDER_LOC_GEO_FAIL: 'new_order_loc_geo_fail',
  NEW_ORDER_LOC_CHOOSE_MAP: 'new_order_loc_choose_map',
  NEW_ORDER_LOC_PRM_ADDR: 'new_order_loc_prm_addr',
  NEW_ORDER_LOC_SEC_ADDR: 'new_order_loc_sec_addr',
  NEW_ORDER_LOC_CITY: 'new_order_loc_city',
  NEW_ORDER_LOC_COUNTRY: 'new_order_loc_country',
  NEW_ORDER_LOC_POSTAL: 'new_order_loc_postal',
  NEW_ORDER_PAY_CARD: 'new_order_pay_card',
  NEW_ORDER_TIME_TASKDONE: 'new_order_time_taskdone',
  NEW_ORDER_TIME_DESCREQ: 'new_order_time_descreq',
  NEW_ORDER_TIME_HOURS: 'new_order_time_hours',
  NEW_ORDER_DESC_TARGET: 'new_order_desc_target',
  NEW_ORDER_DESC_INV_TEAMCODE: 'new_order_desc_inv_teamcode',
  NEW_ORDER_DESC_DESC_REQ: 'new_order_desc_desc_req',
  NEW_ORDER_DESC_START: 'new_order_desc_start',
  NEW_ORDER_DESC_TASK_TYPE: 'new_order_desc_task_type',
  NEW_ORDER_DESC_ADDTEAM: 'new_order_desc_addteam',
  NEW_ORDER_DESC_ADDWORKER: 'new_order_desc_addworker',
  NEW_ORDER_DESC_INV_WORKER: 'new_order_desc_inv_worker',
  NEW_ORDER_DESC_TEXT_WORKER: 'new_order_desc_text_worker',

  ORDER_DETAILS_NOT_APPRV: 'order_details_not_apprv',
  ORDER_DETAILS_PAY_NOW: 'order_details_pay_now',
  ORDER_DETAILS_PAY_NOW_DIALOG: 'order_details_pay_now_dialog',
  SETTINGS_ORG_TYPE_INVALID_TXT: 'settings_org_type_invalid_txt',

  CARDS_FORM_TITLE: 'cards_form_title',
  CARDS_OPTIONS_LOADING_TEXT: 'cards_options_loading_text',
  CARDS_LIST_CREDIT_CARD_LABEL: 'cards_list_credit_card_label',
  CARDS_LIST_EXPIRES_LABEL: 'cards_list_expires_label',
  CARDS_LIST_REMOVE_LABEL: 'cards_list_remove_label',
  CARDS_LIST_PP_LABEL: 'cards_list_pp_label',
  CARDS_LIST_BILLING_LABEL: 'cards_list_billing_label',
  CARDS_ADD_CARD_LABEL: 'cards_add_card_label',
  CARDS_ADD_CARD_EXPLANATION: 'cards_add_card_explanation',
  CARDS_ADD_CARD_DIALOG_TITLE: 'cards_add_card_dialog_title',
  CARDS_ADD_CARD_DIALOG_FORM_TITLE: 'cards_add_card_dialog_form_title',
  CARDS_ADD_CARD_DIALOG_CARD_NUMBER_LABEL:
    'cards_add_card_dialog_card_number_label',
  CARDS_ADD_CARD_DIALOG_EXPIRY_MONTH_LABEL:
    'cards_add_card_dialog_expiry_month_label',
  CARDS_ADD_CARD_DIALOG_EXPIRY_YEAR_LABEL:
    'cards_add_card_dialog_expiry_year_label',
  CARDS_ADD_CARD_DIALOG_CVV_LABEL: 'cards_add_card_dialog_cvv_label',
  CARDS_ADD_CARD_DIALOG_CVV_HELP_TEXT: 'cards_add_card_dialog_cvv_help_text',
  CARDS_ADD_CARD_ADD_CARD_LABEL: 'cards_add_card_add_card_label',
  CARDS_ADD_CARD_PROCESSING_LABEL: 'cards_add_card_processing_label',
  CARDS_ADD_CARD_CANCEL_LABEL: 'cards_add_card_cancel_label',
  CARDS_ADD_CARD_SUCCESS_TEXT: 'cards_add_card_success_text',
  CARDS_REMOVE_CONFIRM_TITLE: 'cards_remove_confirm_title',
  CARDS_REMOVE_CONFIRM_CONFIRM_LABEL: 'cards_remove_confirm_confirm_label',
  CARDS_REMOVE_CONFIRM_CANCEL_LABEL: 'cards_remove_confirm_cancel_label',
  CARDS_REMOVE_CONFIRM_CONTENT_TEXT: 'cards_remove_confirm_content_text',
  CARDS_REMOVE_SUCCESS_TEXT: 'cards_remove_success_text',
  CARDS_LABEL_TOOLTIP: 'cards_label_tooltip',

  WORKER_REPORTS_TITLE: 'worker_reports_title',
  WORKER_REPORTS_COMPLETED_TASKS: 'html_completed_tasks_title',
  WORKER_REPORTS_PAYMENT_REPORT: 'worker_reports_payment_report',
  WORKER_REPORTS_MERCHANT_LABEL: 'worker_reports_merchant_label',
  WORKER_REPORTS_CREATION_DATE_LABEL: 'worker_reports_creation_date_label',
  WORKER_REPORTS_COMPLETION_DATE_LABEL: 'worker_reports_completion_date_label',
  WORKER_REPORTS_SELECT_SERVICE_LABEL: 'worker_reports_select_service_label',
  WORKER_REPORTS_PERIOD_LABEL: 'worker_reports_period_label',
  WORKER_REPORTS_PERIOD_FROM_LABEL: 'worker_reports_period_from_label',
  WORKER_REPORTS_PERIOD_TO_LABEL: 'worker_reports_period_to_label',
  WORKER_REPORTS_IN_PROGRESS_TEXT: 'worker_reports_in_progress_text',
  WORKER_REPORTS_DOWNLOAD_LABEL: 'worker_reports_download_label',
  WORKER_REPORTS_WORKER_TYPE_SELECTOR_LABEL:
    'worker_reports_worker_type_selector_label',

  ORDERER_REPORTS_REPORT_TEXT: 'orderer_reports_report_text',
  WORKER_REPORTS_REPORT_INPUT_TITLE: 'worker_reports_report_input_title',
  ORDERER_REPORTS_MERCHANT_LABEL: 'orderer_reports_merchant_label',
  ORDERER_REPORTS_CREATION_DATE_LABEL: 'orderer_reports_creation_date_label',
  ORDERER_REPORTS_COMPLETION_DATE_LABEL:
    'orderer_reports_completion_date_label',
  ORDERER_REPORTS_FILTER_BY_LABEL: 'orderer_reports_filter_by_label',
  ORDERER_REPORTS_FILE_TYPE_LABEL: 'orderer_reports_file_type_label',
  ORDERER_REPORTS_PERIOD_LABEL: 'orderer_reports_period_label',
  ORDERER_REPORTS_FROM_DATE_LABEL: 'orderer_reports_from_date_label',
  ORDERER_REPORTS_TO_DATE_LABEL: 'orderer_reports_to_date_label',
  ORDERER_REPORTS_BUTTON_IN_PROGRESS_TEXT:
    'orderer_reports_button_in_progress_text',
  ORDERER_REPORTS_BUTTON_TEXT: 'orderer_reports_button_text',
  ORDERER_REPORTS_SELECT_TYPE_TEXT: 'orderer_reports_select_type_text',
  ORDERER_REPORTS_NO_DATE_TYPE_ERROR: 'orderer_reports_no_date_type_error',
  ORDERER_REPORTS_NO_FILE_TYPE_ERROR: 'orderer_reports_no_file_type_error',
  ORDERER_REPORTS_NO_ORDER_STATE_ERROR: 'orderer_reports_no_order_state_error',

  ORDERER_TEAMS_TITLE: 'orderer_teams_title', // Teams
  ORDERER_TEAMS_CONFIRM_TITLE: 'orderer_teams_confirm_title', // Confirm changes
  ORDERER_TEAMS_CONFIRM_LABEL: 'orderer_teams_confirm_label', // Confirm
  ORDERER_TEAMS_CANCEL_LABEL: 'orderer_teams_cancel_label', // Cancel
  ORDERER_TEAMS_ADD_LABEL: 'orderer_teams_add_label', // Add
  ORDERER_TEAMS_CLOSE_LABEL: 'orderer_teams_close_label', // Close
  ORDERER_TEAMS_REMOVE_LABEL: 'orderer_teams_remove_label', // Remove
  ORDERER_TEAMS_TEAM_NAME_TITLE: 'orderer_teams_team_name_title', // Team name
  ORDERER_TEAMS_TEAM_CODE_TITLE: 'orderer_teams_team_code_title', // Team code
  ORDERER_TEAMS_EXPLANATION: 'orderer_teams_explanation', // You can now create your own private teams of workers.
  // Your first team up to 5 workers is free. When using the
  // associated code (5 own char + 3 system generated),
  // orders will only be visible to your team. If you want
  // more teams or workers, please contact us.
  ORDERER_TEAMS_SEARCH_PLACEHOLDER: 'orderer_teams_search_placeholder', // search my teams
  ORDERER_TEAMS_DETAILS_TITLE: 'orderer_teams_details_title', // Team details
  ORDERER_TEAMS_USER_LABEL: 'orderer_teams_user_label', // User
  ORDERER_TEAMS_ADD_USER_TEXT: 'orderer_teams_add_user_text', // Add user to team
  ORDERER_TEAMS_DELETE_TEAM_LABEL: 'orderer_teams_delete_team_label', // Delete team
  ORDERER_TEAMS_TEAM_NOT_EMPTY_ERROR: 'orderer_teams_team_not_empty_error', // You need to remove all users from the
  // team before you could delete it.
  ORDERER_TEAMS_TEAM_CONFIRM_TEXT: 'orderer_teams_team_confirm_text', // Do you really want to delete this team?
  ORDERER_TEAMS_USER_CONFIRM_TEXT: 'orderer_teams_user_confirm_text', // Do you really want to remove this user from
  // the team?
  ORDERER_TEAMS_ADD_TEAM_TITLE: 'orderer_teams_add_team_title', // Add team
  ORDERER_TEAMS_USER_ALREADY_MEMBER_ERROR:
    'orderer_teams_user_already_member_error', // This user is already member
  // of the team.

  WORKER_TEAMS_TITLE: 'worker_teams_title',
  WORKER_TEAMS_EXPLANATION: 'worker_teams_explanation',
  WORKER_TEAMS_USER_WITHOUT_TEAMS: 'worker_teams_user_without_teams',
  WORKER_TEAMS_CHANGE_TEXT: 'worker_teams_change_text',
  WORKER_TEAMS_PRIVATE_TEAMS_TITLE: 'worker_teams_private_teams_title',

  PRIVATE_CHATS_WORKER_CHATS: 'private_chats_worker_chats',
  PRIVATE_CHAT_DISCUSSION_WITH: 'private_chat_discussion_with',
  PRIVATE_CHAT_DISCUSSION_CLOSED: 'private_chat_discussion_closed',
  PRIVATE_CHAT_NO_DISCUSSION_YET: 'private_chat_no_discussion_yet',
  SEND_WITH_ENTER_BUTTON: 'send_with_enter_button',
  CHAT_SEARCH_FIELD: 'chat_search_field',
  OTHER_WORKERS_FOR_THIS_ORDER: 'other_workers_for_this_order',
  BUTTON_BACK_TO_CHAT_LIST: 'button_back_to_chat_list',
  BUTTON_BACK_TO_CHAT: 'button_back_to_chat',
  BUTTON_GO_TO_ORDER: 'button_go_to_order',
  CHAT_INPUT_PLACEHOLDER: 'chat_input_placeholder', // Write something...
  ERROR_CHAT_SELF_MESSAGE: 'error_chat_self_message',
  INVITE_PEOPLE_TO_SERVICE: 'invite_people_to_service',
  INVITE_PEOPLE_TOOLTIP: 'invite_people_tooltip',
  INVITE_OPTIONAL_SUBSTRING: 'invite_optional_substring',
  INVITE_SUCCESSFULLY_SENT: 'invite_successfully_sent',
  INVITE_NOT_THE_SAME_AS_INVITE_EMAIL: 'not_the_same_as_invite_email',
  INVITE_FIRST_NAME_OF_INVITEE: 'invite_first_name_of_invitee',
  CHAT_ORDER_HAS_BEEN_TAKEN: 'chat_order_has_been_taken',
  CHAT_ORDER_HAS_BEEN_TAKEN_ORDERER: 'chat_order_has_been_taken_orderer',
  CHAT_ORDER_APPLY_NOT_APPROVED: 'chat_order_apply_not_approved',
  CHAT_GOTO_UNREAD_LABEL: 'chat_goto_unread_label',
  CHAT_NEW_LABEL: 'chat_new_label',
  CHAT_UPLOAD_IMAGE: 'chat_upload_image',
  CHAT_IMAGE_LABEL: 'chat_image_label',
  CHAT_INVALID_IMG: 'chat_invalid_image',
  CHAT_UPLOAD_IMAGE_BUTTON: 'chat_upload_image_button',
  CHAT_START_CROPPING: 'chat_start_cropping',
  CHAT_OPEN_PROFILE: 'chat_open_profile',

  SERVICE_ADMIN_PRODUCTS_TITLE: 'service_admin_products_title',
  SERVICE_ADMIN_PRODUCT_TAGS_TITLE: 'service_admin_product_tags_title',
  SERVICE_ADMIN_TAGS_FOR_PRODUCT_TITLE: 'service_admin_tags_for_products_title',
  SERVICE_ADMIN_ADMINISTRATION_TITLE_PART:
    'service_admin_administration_title_part',
  INVALID_INPUT: 'invalid_input',
  SERVICE_ADMIN_BACK_TO_HOME_TITLE: 'service_admin_back_to_home_title',
  SERVICE_ADMIN_ADD_BUTTON_TITLE: 'service_admin_add_button_title',
  SERVICE_ADMIN_RECORD_TITLE: 'service_admin_record_title',
  SERVICE_ADMIN_DETAILS_TEXT: 'service_admin_details_text',
  SERVICE_ADMIN_LOADING_TEXT: 'service_admin_loading_text',
  SERVICE_ADMIN_REQUIRED_FIELD_TEXT: 'service_admin_required_field_text',
  SERVICE_ADMIN_SAVE_BUTTON_TEXT: 'service_admin_save_button_text',
  SERVICE_ADMIN_DELETE_BUTTON_TEXT: 'service_admin_delete_button_text',
  SERVICE_ADMIN_CLOSE_BUTTON_TEXT: 'service_admin_close_button_text',
  NEW_ORDER_REQUIRED_INFORMATION: 'new_order_required_information',
  NEW_ORDER_OPTIONAL_INFORMATION: 'new_order_optional_information',
  NEW_ORDER_TARGET_ORDER: 'new_order_target_order',
  NEW_ORDER_MERCHANT_SPECIFIC: 'new_order_merchant_specific',
  NEW_ORDER_SUCCESSFULLY_CREATED: 'new_order_successfully_created',
  NEW_ORDER_TARGET_DESC: 'new_order_target_desc',

  TOOLTIPS_TARGET_TASK_DESC: 'tooltips_target_task_desc',
  TOOLTIPS_TARGET_ADDITIONAL_INFO: 'tooltips_target_additional_info',
  TOOLTIPS_TARGET_PUBLIC_TEAM: 'tooltips_target_public_team',
  TOOLTIPS_TEAM_CODE: 'tooltips_team_code',
  TOOLTIPS_DISTANCE_WORK: 'tooltips_distance_work',
  TOOLTIPS_SETTINGS_LANGUAGE: 'tooltips_settings_language',
  TOOLTIPS_SETTINGS_ORG_TYPE: 'tooltips_settings_org_type',
  TOOLTIPS_SETTINGS_ORDERER_DESC: 'tooltips_settings_orderer_desc',
  TOOLTIPS_SETTINGS_WORKER_TYPE: 'tooltips_settings_worker_type',
  TOOLTIPS_SETTINGS_WORKER_DESC: 'tooltips_settings_worker_desc',
  TOOLTIPS_SETTINGS_DISTANCE: 'tooltips_settings_distance',
  TOOLTIPS_HOW_TO_USE_MAPS: 'tooltips_how_to_use_maps',
  TOOLTIPS_TARGET_ORDER_TEAMS: 'tooltips_target_order_teams',
  TOOLTIPS_TARGET_ORDER_WORKER: 'tooltips_target_order_worker',
  TOOLTIPS_ADDITIONAL_HOURS: 'tooltips_additional_hours',
  TOOLTIPS_ADDITIONAL_DAYS: 'tooltips_additional_days',
  TOOLTIPS_ADDITIONAL_MONTH: 'tooltips_additional_month',
  TOOLTIPS_ADDITIONAL_UNITS: 'tooltips_additional_units',
  TOOLTIPS_ADDITIONAL_PRICE: 'tooltips_additional_price',
  TOOLTIPS_NEW_ORDER_TOTAL: 'tooltips_new_order_total',
  TOOLTIPS_REWATCH_NEW_ORDER_TUT: 'tooltips_rewatch_new_order_tut',

  WORKER_TUTORIAL_00: 'worker_tutorial_00',
  WORKER_TUTORIAL_01: 'worker_tutorial_01',
  WORKER_TUTORIAL_01B: 'worker_tutorial_01b',
  WORKER_TUTORIAL_02: 'worker_tutorial_02',
  WORKER_TUTORIAL_02B: 'worker_tutorial_02b',
  WORKER_TUTORIAL_03: 'worker_tutorial_03',
  WORKER_TUTORIAL_04: 'worker_tutorial_04',
  WORKER_TUTORIAL_05: 'worker_tutorial_05',
  WORKER_TUTORIAL_06: 'worker_tutorial_06',
  WORKER_TUTORIAL_07: 'worker_tutorial_07',
  WORKER_TUTORIAL_08A: 'worker_tutorial_08a',
  WORKER_TUTORIAL_08B: 'worker_tutorial_08b',
  TUTORIAL_REWATCH_TUTORIAL: 'tutorial_rewatch_tutorial',

  ORDERER_TUTORIAL_01: 'orderer_tutorial_01',
  ORDERER_TUTORIAL_02: 'orderer_tutorial_02',
  ORDERER_TUTORIAL_02B: 'orderer_tutorial_02b',
  ORDERER_TUTORIAL_03: 'orderer_tutorial_03',
  ORDERER_TUTORIAL_04: 'orderer_tutorial_04',
  ORDERER_TUTORIAL_05: 'orderer_tutorial_05',
  ORDERER_TUTORIAL_06: 'orderer_tutorial_06',
  ORDERER_TUTORIAL_07: 'orderer_tutorial_07',
  ORDERER_TUTORIAL_08: 'orderer_tutorial_08',
  SKIP_TUTORIAL: 'tutorial_skip_tutorial',
  TUTORIAL_FINISH: 'tutorial_finish',

  NEW_ORDER_TUTORIAL_00: 'new_order_tutorial_00',
  NEW_ORDER_TUTORIAL_01: 'new_order_tutorial_01',
  NEW_ORDER_TUTORIAL_02: 'new_order_tutorial_02',
  NEW_ORDER_TUTORIAL_03: 'new_order_tutorial_03',
  NEW_ORDER_TUTORIAL_04: 'new_order_tutorial_04',
  NEW_ORDER_TUTORIAL_05: 'new_order_tutorial_05',
  NEW_ORDER_TUTORIAL_06: 'new_order_tutorial_06',
  NEW_ORDER_TUTORIAL_07: 'new_order_tutorial_07',
  NEW_ORDER_TUTORIAL_08: 'new_order_tutorial_08',
  NEW_ORDER_TUTORIAL_09: 'new_order_tutorial_09',
  NEW_ORDER_TUTORIAL_10: 'new_order_tutorial_10',
  NEW_ORDER_TUTORIAL_11: 'new_order_tutorial_11',
  NEW_ORDER_TUTORIAL_12: 'new_order_tutorial_12',

  WEBSOCKET_ERROR_CAN_NOT_CONNECT: 'websocket_error_can_not_connect',
  UNSUPPORTED_BROWSER: 'unsupported_browser_message',
};
